@file:OptIn(InternalResourceApi::class)

package ssoft.frontend.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/ssoft.frontend.generated.resources/"

internal val Res.drawable.logo_login_dark: DrawableResource by lazy {
      DrawableResource("drawable:logo_login_dark", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_login_dark.png", -1, -1),
      ))
    }

internal val Res.drawable.logo_panel_dark: DrawableResource by lazy {
      DrawableResource("drawable:logo_panel_dark", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_panel_dark.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("logo_login_dark", Res.drawable.logo_login_dark)
  map.put("logo_panel_dark", Res.drawable.logo_panel_dark)
}
